module.exports = __webpack_public_path__ + "static/img/xiaochengxu.b8e5394.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xiaochengxu.jpg
// module id = MsKT
// module chunks = 1